<template>
    <svg class="icon" aria-hidden="true"><use :xlink:href="'#icon-' + icon"></use></svg>
</template>

<script>
    export default {
        props: ['icon']
    }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/lfl-icon.vue